var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Picto"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 7.5,
    r: 6.4,
    stroke: "white",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84817 9.7374L5.17404 7.96034C4.94197 7.71401 4.94197 7.3147 5.17415 7.06837C5.40612 6.82204 5.78254 6.82216 6.01451 7.06837L6.84817 7.95335L8.98558 5.68466C9.21755 5.43845 9.59397 5.43845 9.82594 5.68466C10.058 5.93099 10.058 6.33042 9.82594 6.57663L6.84817 9.7374Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.587d9ec547981dc2669669ce8bc248b7.svg";
export { ForwardRef as ReactComponent };